// ***********************************************************
// *														 *
// * Multiple File Upload (MFU) settings      				 *
// * Required options for products			  				 *
// *														 *
// *** <Format> **********************************************
// * Product ID : [Required Option,...]						 *
// ***********************************************************
var productIDsforMFU = {
    //*** Example
  	'0000000000000':['Case ID','Shade','Finishing'],	// Fake Product ID
    //*** Menu - Full Crowns 
  	'1922608693336':['Case ID','Shade','Finishing'],	// Haus HT Crown
  	'1353103933528':['Case ID','Shade','Finishing'],	// Haus ML Crown
  	'4018857443416':['Case ID','Shade','Finishing'],	// Haus Sapphire Crown
    '6089693462696':['Case ID','Shade','Finishing'],	// Haus ML 3D Pro Crown (12/03/2020)
  	'1326548582488':['Case ID','Shade','Finishing'],	// BruxZir 16 Crown
  	'2025421045848':['Case ID','Shade','Finishing'],	// NexxZr T Crown
  	'1923408592984':['Case ID','Shade','Finishing'],	// Aidite 3D Multilayer Crown
  	'1326550876248':['Case ID','Shade','Finishing'],	// ArgenZ™ HT+ Crown
  	'1326553071704':['Case ID','Shade','Finishing'],	// ArgenZ™ Anterior Crown
  	'3966636654680':['Case ID','Shade','Finishing'],	// KATANA™ STML Crown
  	'1335878058072':['Case ID','Shade','Finishing'],	// KATANA™ UTML Crown
  	'1326555594840':['Case ID','Shade','Finishing'],	// 3M™ Lava™ Esthetic Crown
  	'4499361366153':['Case ID','Shade','Finishing'],	// Cercon® xt ML Crown
  	'4502171287689':['Case ID','Shade','Finishing'],	// IPS e.max® ZirCAD® Prime Crown
  	//'4513511932041':['Case ID','Shade','Crystallization or Green State'],	// IPS e.max® CAD Full Crown => IPS e.max®LT CAD Full Crown
  	//'5786463469736':['Case ID','Shade','Crystallization or Green State'],	// IPS e.max®HT CAD Full Crown
  	//'5786490765480':['Case ID','Shade','Crystallization or Green State'],	// IPS e.max®MT CAD Full Crown
  	'4509115285641':['Case ID','High Polish'],			// Scheftner Titanium Full Crown
  	'4509116039305':['Case ID','High Polish'], 			// Scheftner Chrome Cobalt Full Crown
	//'7965443358967':['Case ID','Shade','White Coloring','Finishing'],		// Layzir Crown (09/10/2023)
	'7965443358967':['Case ID','Shade','Masking Opaque','Finishing'],		// Layzir Crown -> 10/01/2025 "White Coloring" to "Masking Opaque" 
  	//*** Menu - Happy Hour
  	'4579316170889':['Case ID','Shade'],				// HAPPY HOUR Haus HT Crown
  	'4579350511753':['Case ID','Shade'],				// HAPPY HOUR Haus ML Crown
  	'4579360768137':['Case ID','Shade'],				// HAPPY HOUR Haus Sapphire Crown
  	'6096414998696':['Case ID','Shade'],				// Happy Hour Haus ML 3D Pro Crown (12/03/2020)
  	//*** Menu - Happy Hour (Added 06152023)
  	'7934202478839':['Case ID','Shade','Finishing'],				// HAPPY HOUR Haus HT Plus Crown
  	'7934210015479':['Case ID','Shade','Finishing'],				// HAPPY HOUR Haus ML Plus Crown
  	'7934210310391':['Case ID','Shade','Finishing'],				// HAPPY HOUR Haus Sapphire Plus Crown
  	//*** Menu - Copings
  	'1335874781272':['Case ID','Shade'],				// Haus HT Coping
  	'1326566801496':['Case ID','Shade'],				// BruxZir® 16 Coping
    //'4513020444809':['Case ID','High Polish'],		// Scheftner Titanium Coping (07/28/2024, Remove High Polish Option)
  	//'4513022214281':['Case ID','High Polish'],		// Scheftner Chrome Cobalt Coping (07/28/2024, Remove High Polish Option)
    '4513020444809':['Case ID'],			            // Scheftner Titanium Coping
  	'4513022214281':['Case ID'],			            // Scheftner Chrome Cobalt Coping
    '2025423372376':['Case ID','Shade'],				// NexxZr T Coping
  	'1335876157528':['Case ID','Shade'],				// ArgenZ™ HT+ Coping
  	'1335875829848':['Case ID','Shade'],				// 3M™ Lava™ Esthetic Coping
  	//*** Menu - Cut-Back Crowns
  	'1335881269336':['Case ID','Shade'],				// Haus HT Cut-back Crown
  	'1923393028184':['Case ID','Shade'],				// Haus ML Cut-back Crown
  	'4036716691544':['Case ID','Shade'],				// Haus Sapphire Cut-Back Crown
  	'6096445997224':['Case ID','Shade'],				// Haus ML 3D Pro Cut-Back Crown (12/03/2020)
  	'1335881465944':['Case ID','Shade'],				// BruxZir® 16 Cut-Back Crown
  	'2025426190424':['Case ID','Shade'],				// NexxZr T Cut-Back Crown
  	'1335881629784':['Case ID','Shade'],				// ArgenZ™ HT+ Cut-back Crown
  	'1923391946840':['Case ID','Shade'],				// ArgenZ™ Anterior Cut-Back Crown
  	'1335882186840':['Case ID','Shade'],				// 3M™ Lava™ Esthetic Cut-Back Crown
  	'4503906877577':['Case ID','Shade'],				// Cercon® xt ML Cut-Back Crown
  	'4503906058377':['Case ID','Shade'],				// IPS e.max® ZirCAD® Prime Cut-Back Crown
	//'7965446799607':['Case ID','Shade','White Coloring'],			// Layzir Cut-back Crown (09/10/2023)
	'7965446799607':['Case ID','Shade','Masking Opaque'],			// Layzir Cut-back Crown -> 10/01/2025 "White Coloring" to "Masking Opaque" 
  	//*** Menu - Implant Crowns (Disabled on 2/4/2021)
	//'1353100853336':['Case ID','Shade','Ti-Base','Extra Final Screw','Finishing'],	// Haus HT Implant Crown
  	//'1353104195672':['Case ID','Shade','Ti-Base','Extra Final Screw','Finishing'],	// Haus ML Implant Crown
  	//'4045746536536':['Case ID','Shade','Ti-Base','Extra Final Screw','Finishing'],	// Haus Sapphire Implant Crown
  	//'6095974924456':['Case ID','Shade','Ti-Base','Platform Size K','Extra Final Screw','Finishing'],	// Haus ML 3D Pro Implant (12/03/2020)
  	//'1335877763160':['Case ID','Shade','Ti-Base','Extra Final Screw','Finishing'],	// 3M™ Lava™ Eshtetic Implant Crown
  	//'4513164263561':['Case ID','Shade','Ti-Base','Extra Final Screw','Finishing'],	// NexxZr T Implant Crown
  	//'1353125199960':['Case ID','Shade','Ti-Base','Extra Final Screw','Finishing'],	// ArgenZ™ HT+ Implant Crown
  	//'1335877501016':['Case ID','Shade','Ti-Base','Extra Final Screw','Finishing'],	// BruxZir® 16 Implant Crown
  	//'5697907228840':['Case ID','Shade','Ti-Base','Extra Final Screw','Finishing'],	// IPS E.MAX® ZIRCAD® PRIME IMPLANT CROWN
  	//*** Menu - Custom Abutment + Implant Crown 
  	//(Custom Abutment + Implant Crown Product has no STL file option)
  	//*** Menu - Custom Abutments
  	//'1960075788376':['Case ID','Compatible With','Extra Final Screw','Gold Anodizing'],	// Haus Custom Titanium Abutment (Disabled on 10/04/2023)
  	//'1335877075032':['Case ID','Shade','Ti-Base','Cementation','Extra Final Screw'],	// Haus Custom Hybrid Abutment (Disabled on 10/04/2023)
    //'4513198080137':['Case ID','Compatible With','Extra Final Screw','Gold Anodizing','Buccal Margin 1.00mm Subgingival','Distal Margin 0.50mm Subgingival','Mesial Margin 0.50mm Subgingival','Lingual Margin 0.00mm Subgingival'],	// DESS® Custom Chrome Cobalt Abutment (Disabled on 10/04/2023)
	//*** Menu - Full Arch Prosthesis
  	//'2079033622616':['Case ID','Screws','Pink Anodizing'],				// Scheftner Titanium Bar (Disabled on 05/13/2025)
  	//'4585035268233':['Case ID','Screws'],								// Scheftner Chrome Cobalt Bar (Disabled on 05/13/2025)
  	//'4585044541577':['Case ID','Screws'],								// Tri-Lor Implant Bar (Disabled on 05/13/2025)
  	'4585048375433':['Case ID','Shade','Green State or Sintered'],		// Haus Zirconia Full Arch Hybrid
  	//'4585050013833':['Case ID','Shade','Finishing'],					// Haus PMMA Full Arch Hybrid (Disabled on 05/13/2025)
  	//*** Menu - Temporary Crowns
  	'1353139585112':['Case ID','Shade','Finishing'],								// Haus PMMA Crown
  	'1353142075480':['Case ID','Shade','Finishing'],								// Harvest Dental™ PMMA Crown
	//'4513180287113':['Case ID','Shade','Ti-Base','Extra Final Screw','Finishing'],	// Haus PMMA Implant Crown (Disabled on 06/11/2023)
	//*** Menu - Haus Sapphire Plus (Added 04232023)
	'7912542372087':['Case ID','Shade'],								// Haus Sapphire Plus Cut-Back Crown 
	'7912157446391':['Case ID','Shade','Finishing'],					// Haus Sapphire Plus Crown
	'7912573632759':['Case ID','Shade'],								// Haus Sapphire Plus Coping
	//*** Menu - Haus ML Plus (Added 04232023)
	'7912541618423':['Case ID','Shade'],								// Haus ML Plus Cut-Back Crown
	'7912156922103':['Case ID','Shade','Finishing'],					// Haus ML Plus Crown
	'7912573337847':['Case ID','Shade'],								// Haus ML Plus Coping
	//*** Menu - Haus HT Plus (Added 04232023)
	'7912539717879':['Case ID','Shade'],								// Haus HT Plus Cut-Back Crown
	'7912153678071':['Case ID','Shade','Finishing'],					// Haus HT Plus Crown
	'7912573206775':['Case ID','Shade'],								// Haus HT Plus Coping
	//*** Menu - Haus Essential (Added 01262025)
	//'9591177773303':['Case ID','Shade','White Coloring','Finishing'],	// Haus Essential Crown
	'9591177773303':['Case ID','Shade','Masking Opaque','Finishing'],	// Haus Essential Crown -> 10/01/2025 "White Coloring" to "Masking Opaque" 
	//'9591219159287':['Case ID','Shade','White Coloring']				// Haus Essential Cut-Back Crown
	'9591219159287':['Case ID','Shade','Masking Opaque']				// Haus Essential Cut-Back Crown -> 10/01/2025 "White Coloring" to "Masking Opaque" 
}

// ***********************************************************
// *														 *
// * Multiple File Upload (MFU) settings      				 *
// * Sub options for required options 						 *
// * Show only when required option is selected				 *
// *														 *
// *** <Format> **********************************************
// * [[1stOption, 1stOptionSelected, 2ndOptionRequired],...] *
// ***********************************************************

var subOptionsforMFU = [
	['Crystallization or Green State' , 'Crystallized' , 'Finishing'],
    ['Ti-Base' , 'Yes' , 'Compatible With'],
    ['Compatible With' , 'NOBEL ACTIVE™' , 'Platform Size Active'],
  	['Compatible With' , 'NOBEL REPLACE®' , 'Platform Size Replace'],
  	['Compatible With' , 'NOBEL BRÅNEMARK®' , 'Platform Size Branemark'],
  	['Compatible With' , '3I® OSSEOTITE®' , 'Platform Size Osseotite'],
  	['Compatible With' , '3I® CERTAIN®' , 'Platform Size Certain'],
  	['Compatible With' , 'STRAUMANN® SOFT TISSUE LEVEL SYNOCTA®' , 'Platform Size Synocta'],
  	['Compatible With' , 'STRAUMANN® BONE LEVEL®' , 'Platform Size Bone Level'],
  	['Compatible With' , 'ZIMMER SCREW-VENT®' , 'Platform Size Internal Hex'],
  	['Compatible With' , 'ASTRA EV®' , 'Platform Size EV'],
  	['Compatible With' , 'ASTRA TECH™' , 'Platform Size Osseospeed'],
  	['Compatible With' , 'FRIADENT® XIVE®' , 'Platform Size Xive'],
  	['Compatible With' , 'ANKYLOS® C/X' , 'Platform Size Ankylos'],
  	['Compatible With' , 'Hiossen / Osstem ET® ' , 'Platform Size U'],
  	['Compatible With' , 'CAMLOG®' , 'Platform Size Camlog'],
  	['Compatible With' , 'CONELOG®' , 'Platform Size Conelog'],
  	['Compatible With' , 'BIOHORIZONS® Internal' , 'Platform Size T'],
  	['Compatible With' , 'BIOHORIZONS® External' , 'Platform Size BH External'],
  	['Compatible With' , 'MIS® SEVEN' , 'Platform Size V'],
  	['Compatible With' , 'MEGAGEN® ANYRIDGE' , 'Platform Size ANY'],
  	['Compatible With' , 'DENTIUM®' , 'Platform Size Dentium'],
  	//['Compatible With' , 'Non Engaging - Multiunit' , ''] -- sub option not required
  	['Buccal Margin 1.00mm Subgingival' , 'Other' , 'Your Buccal Margin Setting'],
  	['Distal Margin 0.50mm Subgingival' , 'Other' , 'Your Distal Margin Setting'],
  	['Mesial Margin 0.50mm Subgingival' , 'Other' , 'Your Mesial Margin Setting'],
  	['Lingual Margin 0.00mm Subgingival' , 'Other' , 'Your Lingual Margin Setting'],
  	['Green State or Sintered' , 'Sintered' , 'Finishing']
]


// *** Functions

function enableMFU(productID){
  if (productID in productIDsforMFU){
    document.getElementById("drop-area").style.display = 'block';
  }
}